module.exports = __webpack_public_path__ + "static/6-b28a9e892a4a2d3d97087b7b114cdb4b.png";